import { authHeader } from "../../../../../helpers/authHeader";
import axios from "axios";


export default {
    loadRequests,
    createOrder,
    loadTargets,
    setTarget,
    loadSupplierPrices,
    setSupplierPrice,
    setSupplierPrices
};


function loadRequests() {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+"/procurement/", requestOptions)
        .then((response) => {
            return response.data.data;
        }, (error) => {
            console.log(error.response);
        });
}



function loadTargets() {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+"/procurement/targets", requestOptions)
        .then((response) => {
            return response.data.data;
        }, (error) => {
            console.log(error.response);
        });
}


function setTarget(product_id,warehouse_id,target) {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+"/procurement/targets/"+product_id+"/"+warehouse_id+"/"+target,{}, requestOptions);

}


function loadSupplierPrices() {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.get(process.env.REACT_APP_COORDINATOR_URL+"/procurement/prices", requestOptions)
        .then((response) => {
            return response.data.data;
        }, (error) => {
            console.log(error.response);
        });
}


function setSupplierPrice(product_id, supplier_id, code, price, minQuantity, packageQuantity, id = null) {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+"/procurement/prices/"+product_id+"/"+supplier_id+"/",{
        price,
        minQuantity,
        packageQuantity,
        code,
        id
    }, requestOptions)
        .then((response) => {
            return response.data.data.price;
        });

}


function setSupplierPrices(supplier_id, rows) {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+"/procurement/prices/bulk/" + supplier_id + "/", {
        rows
    }, requestOptions)
        .then((response) => {
            return response;
        });

}



function createOrder(supplier_id, rows) {

    const requestOptions = {
        headers: Object.assign(authHeader(), {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        }),
    };

    return axios.post(process.env.REACT_APP_COORDINATOR_URL+"/procurement/order/create/376423/" + supplier_id, { rows }, requestOptions)
        .then((response) => {
            return response.data.data;
        }, (error) => {
            console.log(error.response);
        });
}





// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/Procurement/api/index.js